import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cross_s",
  "use": "cross_s-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"cross_s\"><path fill-rule=\"evenodd\" d=\"M13 4.538 11.461 3 8 6.462 4.538 3 3 4.538 6.462 8 3 11.461 4.538 13 8 9.538 11.461 13 13 11.461 9.538 8z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol